import { IDictionary } from './types/common'
import { ICXF } from './types/cxf'
import { IStore } from './types/store'

export function initializeStore(cxf: ICXF): IStore {
    return {
        isCanvas: false,
        playerId: cxf.playerId,
        instanceId: cxf.instanceId,
        networkId: cxf.networkId,
        gameId: cxf.gameId,
        gameApi: cxf.gameApi,
        language: cxf.language,
        token: cxf.token,
        zoneId: cxf.zoneId,
        gameEvents: [],
        xp: 0,
        level: 0,
        legendLevel: undefined,
        countryCode: '',
        lastPurchaseTab: '',
        subscriptionDisabled: false,
        isTempServer: false,
        customizationSuffix: '',
        resolvedCustomizationUrl: '',
        sourceId: 'unknown',
        unreadOfferNotifsCountUrl: '',
    }
}

export function criteriaSelector({ legendLevel, level }: IStore): IDictionary<any> {
    return {
        legendLevel,
        level,
    }
}
